var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.563 11.587c2.22 6.84-.277 14.519-6.102 18.707a16.35 16.35 0 0 1-19.556 0C1.08 25.966-1.417 18.428.802 11.587 3.022 4.747 9.402 0 16.613 0c7.351 0 13.731 4.747 15.95 11.587zM16.752 1.536c-6.519 0-12.344 4.188-14.424 10.47-2.08 6.282.139 13.123 5.548 17.032a14.904 14.904 0 0 0 17.752 0c5.27-3.91 7.49-10.75 5.548-17.032-2.08-6.282-7.905-10.47-14.424-10.47z",
    fill: "#313546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.675 13.944V23h-2.477v-9.056h2.477zm.198-2.497a1.46 1.46 0 0 1-1.446 1.466c-.793 0-1.427-.654-1.427-1.466 0-.793.634-1.447 1.427-1.447s1.447.654 1.447 1.447zm9.671 5.984V23h-2.477v-4.617c0-2.775-3.29-2.557-3.29 0V23H15.32v-9.056h2.457v1.466c1.15-2.14 5.767-2.299 5.767 2.021z",
    fill: "#313546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlack);
export default __webpack_public_path__ + "static/media/linkedinBlack.904ab6553a76be82fc57a2c02a73dd46.svg";
export { ForwardRef as ReactComponent };